import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Center,
  VStack,
} from "@chakra-ui/react";
import { useUserCustomerListSuspense } from "gen/endpoints/users/users";
import { CustomerData } from "gen/model/customerData";
import React from "react";
import { useTranslation } from "react-i18next";
import { useClickableElementProps } from "shared/components/clickable/ClickableElementProps";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";

export const AppCustomerSelectPage: React.FC = () => {
  const { t } = useTranslation(["common"]);

  const { data: customers } = useUserCustomerListSuspense();

  return (
    <PageContent isFullHeight={true}>
      <PageBody>
        <Center flex={1}>
          <Card width="md">
            <CardHeader textStyle="h4">{t("common:select_account")}</CardHeader>
            <CardBody mt="-8px">
              <VStack overflowY="auto" maxHeight="300px" alignItems="stretch">
                {customers
                  .filter((c) => !!c.web_domain)
                  .map((customer) => (
                    <CustomerButton key={customer.id} customer={customer} />
                  ))}
              </VStack>
            </CardBody>
          </Card>
        </Center>
      </PageBody>
    </PageContent>
  );
};

const CustomerButton: React.FC<{
  customer: CustomerData;
}> = ({ customer }) => {
  const newUrl = new URL("/", window.location.href);
  newUrl.hostname = customer.web_domain!;

  const props = useClickableElementProps({
    type: "generic",
    to: newUrl.toString(),
    target: "_self",
  });

  return (
    <Button
      colorScheme="secondary"
      justifyContent="flex-start"
      px="16px"
      py="12px"
      key={customer.id}
      {...props}
    >
      {customer.name}
    </Button>
  );
};
